<!-- src/views/project/ReservationsCalendar.vue -->
<template>
  <v-card
    :style="cardStyle"
    class="rounded-xl"
  >
    <v-card-title class="d-flex align-center">
      {{ $t("Calendrier des réservations") }}
      <v-spacer />
      <v-btn
        icon
        @click="fetchEvents"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-toolbar
      flat
      dense
    >
      <v-btn
        icon
        @click="prev"
        ><v-icon>mdi-chevron-left</v-icon></v-btn
      >
      <v-btn
        text
        @click="today"
        >{{ $t("Aujourd'hui") }}</v-btn
      >
      <v-btn
        icon
        @click="next"
        ><v-icon>mdi-chevron-right</v-icon></v-btn
      >

      <!-- Filtre par événement -->
      <v-select
        v-model="selectedEvent"
        :items="eventsList"
        item-text="name"
        item-value="id"
        label="Événement"
        dense
        hide-details
        outlined
        style="max-width: 200px; margin: 0 1rem"
        @change="fetchEvents"
      >
        <template #prepend-item>
          <v-list-item @click="selectAll">
            <v-list-item-title><em>Tous les événements</em></v-list-item-title>
          </v-list-item>
          <v-divider />
        </template>
      </v-select>

      <v-spacer />

      <v-select
        :items="viewTypes"
        v-model="viewType"
        item-text="text"
        item-value="value"
        dense
        hide-details
        outlined
        style="max-width: 140px"
      />
    </v-toolbar>

    <v-card-text
      class="pa-0"
      style="height: 650px"
    >
      <v-sheet
        tile
        height="100%"
      >
        <v-calendar
          v-model="viewStart"
          :type="viewType"
          :events="events"
          locale="fr"
          event-overlap-mode="stack"
          @click:event="onEventClick"
          style="height: 100%"
        >
          <template #event="{ event }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div
                  class="calendar-event-chip"
                  v-bind="attrs"
                  v-on="on"
                  :style="{ backgroundColor: event.color }"
                >
                  {{ event.name }}
                </div>
              </template>
              <pre class="ma-0">{{ event.tooltip }}</pre>
            </v-tooltip>
          </template>
        </v-calendar>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
import { ProjectService, ReservationService } from "@/services"
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "ReservationsAdminCalendar",
  data() {
    return {
      events: [],
      eventsList: [],
      selectedEvent: null,
      viewStart: new Date().toISOString().substr(0, 10),
      viewType: "month",
      viewTypes: [
        { text: "Mois", value: "month" },
        { text: "Semaine", value: "week" },
        { text: "Jour", value: "day" }
      ],
      colorPalette: [
        "#E53935",
        "#8E24AA",
        "#3949AB",
        "#039BE5",
        "#43A047",
        "#FDD835",
        "#FB8C00",
        "#D81B60"
      ]
    }
  },
  computed: {
    cardStyle() {
      return { backgroundColor: getTheme(this).bgCard }
    }
  },
  methods: {
    pad(n) {
      return String(n).padStart(2, "0")
    },
    formatForCalendar(d) {
      return (
        `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())} ` +
        `${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`
      )
    },

    // Charge la liste des events pour le filtre
    async fetchEventsList() {
      let companyId = this.$store.getters["app/getCompany"].pk
      const resp = await ProjectService.get(this, companyId)
      this.eventsList = resp.results
    },
    // Sélection "Tous les événements"
    selectAll() {
      this.selectedEvent = null
      this.fetchEvents()
    },

    // Charge les réservations (toutes ou filtrées)
    async fetchEvents() {
      const resp = await ReservationService.getAllCalendar(this, this.selectedEvent)
      this.events = resp.results.map((r, i) => {
        const start = new Date(r.start)
        const end = new Date(r.end)
        return {
          id: r.id,
          name: r.title,
          start: this.formatForCalendar(start),
          end: this.formatForCalendar(end),
          timed: true,
          tooltip: r.tooltip,
          color: this.colorPalette[i % this.colorPalette.length]
        }
      })
    },

    prev() {
      const date = new Date(this.viewStart)
      if (this.viewType === "month") date.setMonth(date.getMonth() - 1)
      else if (this.viewType === "week") date.setDate(date.getDate() - 7)
      else date.setDate(date.getDate() - 1)
      this.viewStart = date.toISOString().substr(0, 10)
    },
    next() {
      const date = new Date(this.viewStart)
      if (this.viewType === "month") date.setMonth(date.getMonth() + 1)
      else if (this.viewType === "week") date.setDate(date.getDate() + 7)
      else date.setDate(date.getDate() + 1)
      this.viewStart = date.toISOString().substr(0, 10)
    },
    today() {
      this.viewStart = new Date().toISOString().substr(0, 10)
    },
    onEventClick({ event }) {
      this.$router.push({
        name: "ReservationCreateUpdate",
        params: { id: event.id }
      })
    }
  },
  mounted() {
    this.fetchEventsList()
    this.fetchEvents()
  }
}
</script>

<style scoped>
.calendar-event-chip {
  padding: 4px 8px;
  font-size: 0.75rem;
  border-radius: 4px;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-sheet {
  padding: 0 !important;
}
</style>
